routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.cart', {
      url: "/canasta",
      template: `<cart sh-ctrl="shCtrl"></cart>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/cart/cart.config.js
 **/